class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    // Animate out before removing open
    var modal = this.detailsContainer.querySelector('.search-modal');
    if (modal) {
      modal.style.transition = 'opacity 0.2s ease';
      modal.style.opacity = '0';
      setTimeout(function() {
        this.detailsContainer.removeAttribute('open');
        modal.style.transition = '';
        modal.style.opacity = '';
      }.bind(this), 200);
    } else {
      this.detailsContainer.removeAttribute('open');
    }

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.style.removeProperty('--scrollbar-width');

    // Notify header it can go back to transparent
    var headerWrapper = document.querySelector('.header-wrapper[data-transparent-header]');
    if (headerWrapper) {
      headerWrapper.classList.remove('header-modal-open');
      if (headerWrapper.classList.contains('header-wrapper-transparent') && !headerWrapper.classList.contains('header-wrapper-hovered')) {
        var colorClass = headerWrapper.getAttribute('data-header-color-class');
        if (colorClass) {
          colorClass.split(' ').forEach(function(c) { if (c) headerWrapper.classList.remove(c); });
        }
      }
    }
  }
}

customElements.define('details-modal', DetailsModal);
